import { Modal, Button, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import "./AddContentDialog.css";
import React, { useState, useEffect } from "react";
import DataTable from "../../../Tables/DataTable/DataTable";
import { useLoading } from "../../../../hooks/useLoader";
import { useMasterData } from "../../../../hooks/useMasterData";
import ApiServices from "../../../../services/ApiServices";
import {
  BUNDLE,
  PARENT_DISTRIBUTOR,
} from "../../../../constants/api-constants";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { toast } from "react-toastify";
import Filter from "../../../../common/Filter/Filter";
import TableColumnModal from "../../../../common/TableColumnModal/TableColumnModal";
import { ListOfContentCatalogDataColumns } from "../../../../common/TableColumnModal/ContentDataColumns";
import { FILTER_OPTION } from "../../../../constants/filterOptions";
import {
  SelectionFilter,
  GetAllSelectedIds,
  ClearSelectionData,
} from "../../../../utilities/SelectionFilter";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { ContentPublishStatus } from "../../constants";
import PropTypes from "prop-types";

const BUNDLE_MODAL_COLUMN_STORAGE_KEY = "bundleAddContentDialog";
const BUNDLE_FIXED_MODAL_COLUMNS = ["formNumber", "name", "documentType", "typeOfContentText"];
const BUNDLE_DEFAULT_VISIBLE_MODAL_COLUMNS = [
  ...BUNDLE_FIXED_MODAL_COLUMNS,
  "typeOfFormList",
  "lineOfBusinessList",
  "filePath",
];

const BUNDLE_MODAL_COLUMN_WIDTHS = {
  formNumber: 130,
  name: 180,
  documentType: 90,
  typeOfContentText: 160,
  typeOfFormList: 140,
  lineOfBusinessList: 120,
  filePath: 160,
  userName: 130,
  contentOriginator: 150,
  fillableText: 90,
  countryName: 110,
  states: 130,
  latestVersion: 120,
  marketingDescription: 180,
  keywords: 140,
  tages: 160,
  createdOn: 120,
  createdByName: 130,
  updatedOn: 130,
  updatedByName: 130,
  numberOfEnrolledUser: 120,
  isPublic: 120,
  contentTypeText: 150,
  publishStatus: 100,
};

const getBundleModalColumns = (storedColumns = []) => {
  const columnsByField = new Map(
    ListOfContentCatalogDataColumns.map((column) => [column.fieldName, column])
  );
  const storedColumnsByField = new Map(
    storedColumns.map((column) => [column.fieldName, column])
  );
  const orderedFields = [
    ...BUNDLE_DEFAULT_VISIBLE_MODAL_COLUMNS,
    ...ListOfContentCatalogDataColumns.map((column) => column.fieldName).filter(
      (fieldName) => !BUNDLE_DEFAULT_VISIBLE_MODAL_COLUMNS.includes(fieldName)
    ),
  ];

  let leftOffset = 0;

  return orderedFields
    .map((fieldName) => columnsByField.get(fieldName))
    .filter(Boolean)
    .map((column) => {
      const storedColumn = storedColumnsByField.get(column.fieldName);
      const isFixed = BUNDLE_FIXED_MODAL_COLUMNS.includes(column.fieldName);
      const configuredWidth = BUNDLE_MODAL_COLUMN_WIDTHS[column.fieldName];
      const defaultWidth = Number(column.width);
      let width = 140;

      if (Number.isFinite(configuredWidth)) {
        width = configuredWidth;
      } else if (Number.isFinite(defaultWidth)) {
        width = defaultWidth;
      }

      const nextColumn = {
        ...column,
        width,
        textOverflowWidth: width,
        isSelected:
          storedColumn?.isSelected ??
          BUNDLE_DEFAULT_VISIBLE_MODAL_COLUMNS.includes(column.fieldName),
        isFixed,
        fixedSide: isFixed ? "left" : undefined,
        leftPadding: isFixed ? leftOffset : undefined,
        rightPadding: undefined,
      };

      if (isFixed) {
        leftOffset += width;
      }

      return nextColumn;
    });
};

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -40%)",
  width: "1100px !important",
  bgcolor: "#fff",
  border: "1px solid #000",
  boxShadow: 24,
  p: 0,
};
/*istanbul ignore next */
const AddContentDialog = (props) => {
  const { open, closeDialogHandler, userId, contentId, listContentData, id } =
    props;
  const { showLoader } = useLoading();
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [catalogFilterOptions, setCatalogFilterOptions] = React.useState(
    FILTER_OPTION.ADD_CATALOG_LIST
  );
  const [adminTable, setAdminTableData] = useState([]);
  const [isNew, setIsNew] = useState(false);
  const [showFilter, setshowFilter] = useState(false);
  const [tableColumnModalVisibility, setTableColumnModalVisibility] =
    useState(false);
  const [query, setQuery] = useState({
    searchText: "",
    SortType: "desc",
    IgnorePaging: true,
    SortColumn: "userId",
    PageNumber: 1,
    PageSize: 10,
    filter: {
      status: [1],
      publishStatus:
        props.publishStatus === ContentPublishStatus.PUBLISHED ? [1] : [],
    },
  });

  const [selectedItem, setSelectedItem] = useState({});
  const masterDataContext = useMasterData();

  useEffect(() => {
    ClearSelectionData();
  }, []);

  useEffect(() => {
    getContentList();
    setSelectionColumns();
  }, [query]);

  const loadDropdownOption = async () => {
    try {
      showLoader(true);
      const response = masterDataContext.masterDataValue;
      const distributorresponse = await ApiServices.httpGet(PARENT_DISTRIBUTOR);
      showLoader(false);
      const catalogOptions = [...catalogFilterOptions];

      // LOB
      catalogOptions[3].options = response.result.lineOfBusiness.map((r) => {
        return {
          value: r.lineOfBusinessId,
          roleId: r.lineOfBusinessId,
          label: r.name,
        };
      });
      // Type of Form
      catalogOptions[5].options = response.result.typeOfForm.map((r) => {
        return {
          value: r.typeOfFormId,
          roleId: r.typeOfFormId,
          label: r.name,
        };
      });
      // Countries
      catalogOptions[1].options = response.result.countries.map((r) => {
        return {
          value: r.countryId,
          roleId: r.countryId,
          label: r.name,
        };
      });
      catalogOptions[2].options = distributorresponse.result.map((r) => {
        return {
          value: r.userId,
          label: r.name,
        };
      });
      setCatalogFilterOptions(catalogOptions);
    } catch (e) {
      showLoader(false);
    }
  };

  useEffect(() => {
    if (!loaded) {
      loadDropdownOption();
      setLoaded(true);
    }
  }, []);
  /*istanbul ignore next */
  const applyModalFilterHandler = (filter) => {
    ClearSelectionData();
    setSelectedItem(filter);
    setQuery((prevState) => {
      return {
        ...prevState,
        filter: {
          ...prevState.filter,
          contentType: filter.contentType || [],
          countries:
            filter.countries?.map((item) => {
              return { countryId: item };
            }) || [],
          userIds:
            filter.distributor?.map((item) => {
              return item;
            }) || [],
          lineOfBusiness:
            filter.lineOfBusiness?.map((item) => {
              return { lineOfBusinessId: item };
            }) || [],
          publishStatus:
            filter.publishStatus?.map((item) => {
              return item;
            }) || [],
          TypeOfContent:
            filter.TypeOfContent?.map((item) => {
              return item;
            }) || [],
          typeOfForm:
            filter.typeOfForm?.map((item) => {
              return { typeOfFormId: item };
            }) || [],
          result:
            filter.result?.map((item) => {
              return { userId: item };
            }) || [],
          DocumentTypes:
            filter.DocumentTypes?.map((item) => {
              return item;
            }) || [],
          contentFillable: filter.contentFillable,
        },
      };
    });
  };

  const setSelectionColumns = () => {
    let selectedCols = localStorage.getItem("selectedColumns")
      ? JSON.parse(localStorage.getItem("selectedColumns"))
      : null;
    const contentDialogCols = selectedCols?.[BUNDLE_MODAL_COLUMN_STORAGE_KEY] || [];
    setSelectedColumns(getBundleModalColumns(contentDialogCols));
  };

  const onCancelTableColumnSelection = () => {
    setTableColumnModalVisibility(false);
    setSelectionColumns();
  };

  const onSaveTableColumnSelection = (componentName, columns) => {
    const normalizedColumns = getBundleModalColumns(columns);
    let oldData = localStorage.getItem("selectedColumns")
      ? JSON.parse(localStorage.getItem("selectedColumns"))
      : null;

    if (oldData) {
      let data = { ...oldData, [componentName]: normalizedColumns };
      localStorage.setItem("selectedColumns", JSON.stringify(data));
    } else {
      let newData = { [componentName]: normalizedColumns };
      localStorage.setItem("selectedColumns", JSON.stringify(newData));
    }

    setSelectedColumns(normalizedColumns);
    setTableColumnModalVisibility(false);
  };

  const getContentList = async () => {
    try {
      let firstParam = userId;
      let secondParam = 0;
      query.IgnorePaging = true;
      const adminData = await ApiServices.httpGet(
        `${BUNDLE}/content/${firstParam}/${secondParam}/${encodeURIComponent(
          JSON.stringify(query)
        )}`
      );
      let checkedIds = listContentData?.map((el) => el.contentId) ?? [];
      if (checkedIds && adminData?.result?.records) {
        adminData.result.records = adminData?.result?.records.filter(
          (ele) =>
            !checkedIds.includes(ele.contentId) &&
            (ele.documentType < 2 || ele.contents?.length > 0)
        );
      }
      let selectedIds = GetAllSelectedIds("contentId");
      adminData.result.records = adminData.result.records.map((record) => ({
        ...record,
        isChecked: selectedIds.includes(record.contentId),
      }));
      setAdminTableData(adminData?.result?.records);
      if (
        !adminData?.result?.records ||
        adminData.result.records.length === 0
      ) {
        setIsNew(false);
      } else {
        setIsNew(adminData.result.records.some((x) => x.isChecked));
      }
    } catch (e) {
      toast.error("Internal server error");
    }
  };
  /*istanbul ignore next */
  const onCheckboxChangeHandler = (e, value) => {
    const { checked } = e.target;
    if (value === "all") {
      setAdminTableData((items) => {
        SelectionFilter(items, "multiple", checked, "contentId");
        return items.map((data) => {
          return {
            ...data,
            isChecked: checked,
          };
        });
      });
    } else {
      setAdminTableData((items) => {
        return items.map((user) => {
          let userRecord = { ...user };
          if (user.contentId === value) {
            SelectionFilter(user, "single", checked, "contentId");
            userRecord.isChecked = checked;
          }
          return userRecord;
        });
      });
    }
    const selectedIds = GetAllSelectedIds("contentId");
    setIsNew(selectedIds.length > 0);
  };
  /*istanbul ignore next */
  const associateContent = async () => {
    try {
      let checkedIds = GetAllSelectedIds("contentId");
      let payload = {
        contentId: contentId,
        userId: userId,
        associateContentIds: [...checkedIds],
      };

      let response = await ApiServices.httpPost(`${BUNDLE}/content`, payload);
      if (response?.responseStatus?.isSuccess) {
        ClearSelectionData();
        toast.success(response.responseStatus.description);
        if (props.publishStatus === ContentPublishStatus.PUBLISHED) {
          toast.success(
            "Bundle need not to be republished. These Content(s) and/or Catalog(s) will automatically appear to the subscriber(s) who has access to this published Bundle."
          );
        }
        closeDialogHandler(false);
      } else {
        toast.error(response?.responseStatus?.error);
      }
    } catch (e) {
      toast.error("Internal server error");
    }
  };
  /*istanbul ignore next */
  const onSearchHandler = (event) => {
    setTimeout(() => {
      setQuery((prevState) => {
        return {
          ...prevState,
          PageNumber: 1,
          searchText: event.target.value,
        };
      });
    }, 1000);
  };
  const handleFilter = (event) => {
    setshowFilter(true);
    setAnchorEl(event.currentTarget);
  };
  /*istanbul ignore next */
  const sortHandler = (sortOrder, sortBy) => {
    setQuery((prevState) => {
      if (prevState.SortColumn === sortBy) {
        return {
          ...prevState,
          SortType: sortOrder === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          ...prevState,
          SortColumn: sortBy,
          SortType: "asc",
        };
      }
    });
  };
  /*istanbul ignore next */
  const onClose = () => {
    setshowFilter(false);
  };
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        closeDialogHandler(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} className="custom-modal-content">
        <div className="modal-header">
          <div className="modal-header-left">List of Items</div>
          <button
            type="button"
            className="modal-header-right"
            onClick={() => {
              closeDialogHandler(false);
            }}
            style={{
              cursor: "pointer",
              background: "none",
              border: "none",
              padding: 0,
            }}
            aria-label="Close"
            data-testid="CloseNewAdminPopup"
          >
            <CloseOutlinedIcon />
          </button>
        </div>
        <div className="modal-body-cus">
          <div className="action-items">
            <div className="dialog-toolbar-actions">
              <div className="add-welcome-widgetsfilter-cus-filter-icon">
                <Tooltip placement="bottom" title="Filter">
                  <FilterAltOutlinedIcon
                    onClick={handleFilter}
                    data-testid="FilterAltOutlinedIcon-uniqueId"
                  />
                </Tooltip>
                <div>
                  {showFilter && (
                    <Filter
                      anchorEl={anchorEl}
                      id={id}
                      open={open}
                      options={catalogFilterOptions}
                      onApplyFilter={applyModalFilterHandler}
                      onClose={handleClose}
                      selected={selectedItem}
                    />
                  )}
                </div>
              </div>
              <div className="add-welcome-widgetsfilter-cus-filter-icon">
                <Tooltip placement="bottom" title="Change View">
                  <BorderColorIcon
                    data-testid="TableColumnSelectionIcon"
                    onClick={() => {
                      setTableColumnModalVisibility(true);
                    }}
                  />
                </Tooltip>
              </div>
            </div>
            <Button
              disabled={!isNew}
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => {
                associateContent();
              }}
              data-testid="dialog-add-button"
              className={isNew ? "add-button-align" : "add-disabled-button"}
            >
              Add
            </Button>
            <Button
              variant="contained"
              startIcon={<CloseIcon />}
              onClick={() => {
                closeDialogHandler(false);
              }}
              data-testid="dialog-cancel-button"
              className="cancel-button-align"
            >
              Cancel
            </Button>
          </div>
          <DataTable
            uniqueKey="contentId"
            onCheckboxChange={onCheckboxChangeHandler}
            columns={selectedColumns}
            query={query}
            adminTable={adminTable}
            onSearch={onSearchHandler}
            onSort={sortHandler}
            paginationNotRequired={true}
          />
          {tableColumnModalVisibility && (
            <TableColumnModal
              componentName={BUNDLE_MODAL_COLUMN_STORAGE_KEY}
              isOpen={tableColumnModalVisibility}
              onCancelTableColumnSelection={onCancelTableColumnSelection}
              onSaveTableColumnSelection={onSaveTableColumnSelection}
              selection={selectedColumns}
            />
          )}
        </div>
        <div className="modal-footer"></div>
      </Box>
    </Modal>
  );
};

AddContentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  closeDialogHandler: PropTypes.func.isRequired,
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  contentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  listContentData: PropTypes.arrayOf(
    PropTypes.shape({
      contentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  publishStatus: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

AddContentDialog.defaultProps = {
  listContentData: [],
  id: null,
  publishStatus: undefined,
};

export default AddContentDialog;
